import { connectorsForWallets } from '@rainbow-me/rainbowkit'
import {
  okxWallet,
  rabbyWallet,
  metaMaskWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets'
import { createConfig as createConfigCore, http as httpCore } from '@wagmi/core'
import { createConfig, http } from 'wagmi'
import { wanchainTestnet, wanchain } from 'wagmi/chains'
import type { Chain } from 'wagmi/chains'

const network: Chain =
  process.env.REACT_APP_CHAINID === '888' ? wanchain : wanchainTestnet
const projectId = (process.env.REACT_APP_PROJECTID || 'MYPROJECT') as string

declare module 'wagmi' {
  interface Register {
    config: typeof config
  }
}

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, rabbyWallet, okxWallet, walletConnectWallet],
    },
  ],
  {
    appName: 'XSTAKE',
    projectId,
  },
)

export const config = createConfig({
  chains: [network],
  transports: {
    [network.id]: http(),
  },
  connectors,
})

export const configCore = createConfigCore({
  chains: [network],
  transports: {
    [network.id]: httpCore(),
  },
})
